(() => {
  if (customElements.get('lp-featured-media-slider')) return;

  class LpFeaturedMediaSlider extends HTMLElement {
    constructor() {
      super();
      this.onSectionLoad = this.onSectionLoad.bind(this);
      this.onWindowLoad = this.onWindowLoad.bind(this);
      this.swiper = null;
    }

    connectedCallback() {
      this.sliderEl = this.querySelector('[data-slider]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');

      if (!this.sliderEl) return;

      this.classList.remove('is-initialized');

      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', this.onWindowLoad, { once: true });
        return;
      }

      this.initSwiper();
    }

    disconnectedCallback() {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }

      window.removeEventListener('load', this.onWindowLoad);
      this.destroySwiper();
    }

    onWindowLoad() {
      this.initSwiper();
    }

    onSectionLoad(event) {
      if (!event.target.contains(this)) return;
      this.destroySwiper();
      this.initSwiper();
    }

    initSwiper() {
      if (typeof Swiper === 'undefined' || this.swiper || !this.sliderEl) return;

      const slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
      if (!slideCount) return;

      const hasMultipleSlides = slideCount > 1;

      this.classList.toggle('has-single-slide', !hasMultipleSlides);

      this.swiper = new Swiper(this.sliderEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: hasMultipleSlides,
        allowTouchMove: hasMultipleSlides,
        navigation: hasMultipleSlides
          ? {
              nextEl: this.nextButton,
              prevEl: this.prevButton,
            }
          : false,
        on: {
          init: () => {
            requestAnimationFrame(() => {
              this.classList.add('is-initialized');
            });
          },
        },
      });
    }

    destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
      this.classList.remove('is-initialized', 'has-single-slide');
    }
  }

  customElements.define('lp-featured-media-slider', LpFeaturedMediaSlider);
})();
